export default {"src":"/_next/static/media/whiteLogo.ecd2351a.svg","height":126,"width":558,"blurWidth":0,"blurHeight":0};